import axios from 'axios';

let focused,
    responseMsg;

export function init() {
    const contactForm = document.querySelector('.js-contact-form'),
        inputs = contactForm.querySelectorAll('input, textarea'),
        submitBtn = document.querySelector('.js-submit');
        
    responseMsg = contactForm.querySelector('.js-message');

    inputs.forEach(input => {
        input.addEventListener('focus', e => {
            focused = input;
        });
    });

    submitBtn.addEventListener('click', e => {
        e.preventDefault();
        
        document.querySelectorAll('.required').forEach(el => {
            el.classList.add('hidden');
        });

        let formData = new FormData(contactForm);

        axios({
            method: 'post',
            url: '/',
            data: formData,
            headers: { "X-Requested-With": "XMLHttpRequest" }
        })
        .then(response => {
            const data = response.data;

            inputs.forEach(input => {
                input.disabled = true;
            });

            submitBtn.classList.add('opacity-0');

            setTimeout(() => {
                submitBtn.classList.add('!hidden');

                showResponseMessage(data);
            }, 300);
        })
        .catch(error => {
            if (typeof error.response.data !== 'undefined') {
                handleErrors (error.response.data);
            }
        });
    });
}

function handleErrors (response) {
    // Show errors for relevant fields
    for (const key in response.errors) {
        document.querySelector(`#${key}-required`).classList.remove('hidden');
    }

    showResponseMessage(response, 'error');

    // Refocus previous field otherwise the name field
    if (focused) {
        focused.focus(); 
    } else {
        document.querySelector('#fromName').focus();
    }
}

function showResponseMessage(response, status = 'success') {
    // Set the response message and Show
    responseMsg.textContent = response.message;
    
    if (status === 'success') {
        responseMsg.classList.add('text-hope-green-700');
        responseMsg.classList.remove('text-red-500');
    } else {
        responseMsg.classList.remove('text-hope-green-700');
        responseMsg.classList.add('text-red-500');
    }

    responseMsg.classList.remove('hidden');
                
    setTimeout(() => {
        responseMsg.classList.remove('opacity-0')
    }, 100);
}